import React from 'react';
import t from '~t';
import pjson from '../../../../package.json';
import config from '~config';

import {
  Section,
  SectionTitle,
  Item,
  ItemIcon,
  ItemTitle,
  ItemLink,
} from '~ui';
import { Icon } from '~ui'

export default function SettingsSidebarApp() {
  return (
    <>
      <Section>
        <SectionTitle>Save {pjson.version}</SectionTitle>
      </Section>

      <Item>
        <ItemIcon>
          <Icon name='help' />
        </ItemIcon>
        <ItemTitle>{t.s('help')}</ItemTitle>
        <ItemLink href={config.links.help.index} target='_blank' />
      </Item>
    </>
  );
}
